<template>
    <div class="paper-info-page">
      <el-container style="height: 100%">
        <el-header style="z-index: 11;">
          <div class="title">
            <div class="title-left">
              <div class="row-1">
                {{ allname }}<span v-if="user_score!= ''" class='score'>（ 得分：{{user_score || '-'}}分，总分：{{paper_score || '-'}}分 ）</span>
              </div>
            </div>
            <div class="title-right">
                <el-button plain class='reject' @click='reject_flag = true' v-if='both_flag'>驳回</el-button>
                <el-button
                        @click="saveAll"
                        type="primary"
                        size="middle"
                        v-if='is_correct_teacher'
                        >
                    保存
                </el-button>
                <el-button
                        type="primary"
                        size="middle"
                        :disabled="is_publish"
                        @click="savePub"
                        >
                    保存并发布给学员
                </el-button>
                <el-dropdown>
                  <span class="el-dropdown-link">
                    <span style="font-weight:700; font-size: 16px; cursor: pointer;">{{ name }}<i class="el-icon-arrow-down el-icon--right"></i></span>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>
                        <span @click="quitSystem()">
                            退出登录
                        </span>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
            </div>
          </div>
        </el-header>
        <el-container style="width: 1200px; margin: 20px auto 50px;">
          <el-aside width="172px" style='height: 582px; background: #fff; border-radius: 8px;' v-bar>
            <div>
              <p class="paper_name" @click='tomain_index' v-if="type == 0"><img src="../../../static/images/note.png" alt="">{{ papername }}</p>
              <el-tree v-if="type == 0" :data="level_data" node-key="level_id" default-expand-all :expand-on-click-node="false" @node-click="handleNodeClick" :props="defaultProps" highlight-current>
                <span class="assembly_level" slot-scope="{data}">
                  <span class="assembly_type" v-show="!data.list"></span>
                  <div v-if='data.block_name' v-html='htmlfilter(data.block_name)' class="desc-html"></div>
                  <span v-else>--</span>
                  <span v-if='data.is_new == 1' class="ask_tip">追问</span>
                </span>
              </el-tree>
              <el-tree v-else-if="type == 1" :data="level_data" node-key="level_id" default-expand-all :expand-on-click-node="false" @node-click="handleNodesClick" highlight-current>
                <span class="assembly_level" slot-scope="{data}">
                  <span class="assembly_type" v-show="!data.children"></span>
                  <div v-if='data.level_name' v-html='htmlfilter(data.level_name)' class="desc-html"></div>
                  <span v-else>--</span>
                  <span v-if='data.is_new == 1' class="ask_tip">追问</span>
                </span>
              </el-tree>
            </div>
          </el-aside>
          <el-main style="margin-left: 20px; background: #fff; border-radius: 8px; padding-left:30px; padding-right: 30px;">
            <router-view></router-view>
          </el-main>
        </el-container>
        <el-footer style="height: 200px;">
          <div class="common">
            <div class="school l">
              <p class="p1"><a>中公网校</a></p>
              <p class="p2"><a target="_blank" href="//www.eoffcn.com/">网校首页</a><a target="_blank" href="//www.eoffcn.com/help/40.html#a">关于我们</a><a target="_blank" href="//www.eoffcn.com/help/40.html#c">联系我们</a><a target="_blank" href="//www.eoffcn.com/kszx/wxdt/117856.html">加入我们</a><a target="_blank" href="//www.eoffcn.com/wzdt/">网站导航</a><a target="_blank" href="//www.eoffcn.com/help/yqlj/">友情链接</a></p>
              <p class="p3">Copyright©2000-2019 中公网校 .All Rights Reserved  京ICP备10218183号-41  京公网安备11010802020664号</p>
            </div>
            <div class="follow_me l">
              <p class="p4">关注我们</p>
              <div class="weibo l" @mouseenter='wb_show' @mouseleave='wb_hide'>
                <div v-if='wb_flag' class="wbtc" id="cony1">
                    <iframe id="iframe" height="118" style=" width:170px; _width:220px;margin-top:-30px;" class="share_self" frameborder="0" scrolling="no" src="//widget.weibo.com/weiboshow/index.php?language=&width=190&height=118&fansRow=2&ptype=1&speed=0&skin=1&isTitle=1&noborder=1&isWeibo=1&isFans=1&uid=2003981861&verifier=3e4ad68d&dpc=1"></iframe>
                </div>
                <div v-if='wb_flag' class="v_bottom_round"><img src="../../../static/images/v_bottom_round.png"></div>
              </div>
              <div class="public l" @mouseenter='vx_show' @mouseleave='vx_hide'>
                 <div v-if='vx_flag' class="weixin_logo"><img src="../../../static/images/assistant.jpg"></div>
                 <div v-if='vx_flag' class="bottom_round"><img src="../../../static/images/bottom_round.png"></div>
              </div>
            </div>
          </div>
        </el-footer>
      </el-container>
        <el-dialog :visible.sync="dialogVisible">
          <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
        <el-dialog title="驳回" :visible.sync="reject_flag">
          <span>驳回原因</span>
          <p><textarea class="dialog_textarea" v-model='reject_text' maxlength="1000"></textarea></p>
          <p class="reject_tip" v-if="reject_tip">请填写驳回原因</p>
          <p v-if="get_reject != ''">历史驳回原因</p>
          <div v-if="get_reject != ''">
            <p v-for='i in get_reject'>{{i.msg}}</p>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="reject_flag = false; reject_tip = false">取 消</el-button>
            <el-button type="primary" @click="reject_comment">确 定</el-button>
          </span>
        </el-dialog>
    </div>
</template>
<script>
    import VideoPlayer from '@/components/video-player'
    import global_ from "../../global/index"

    export default {
        components: {
            VideoPlayer
        },
        computed: {
          comments: {
            get () {
              return this.$store.state.app.comments
            },
            set (value) {
              this.$store.commit('setComments', value)
            }
          },
          upload: {
            get () {
              return this.$store.state.app.upload
            },
            set (value) {
              this.$store.commit('setUpload', value)
            }
          },
          audio: {
            get () {
              return this.$store.state.app.audio
            },
            set (value) {
              this.$store.commit('setAudio', value)
            }
          },
          attachmentFilesList: {
            get () {
              return this.$store.state.app.attachmentFilesList
            },
            set (value) {
              this.$store.commit('setAttachmentFilesList', value)
            }
          },
          part_comments: {
            get () {
              return this.$store.state.app.part_comments
            },
            set (value) {
              this.$store.commit('setPartComments', value)
            }
          },
          part_upload: {
            get () {
              return this.$store.state.app.part_upload
            },
            set (value) {
              this.$store.commit('setPartUpload', value)
            }
          },
          part_audio: {
            get () {
              return this.$store.state.app.part_audio
            },
            set (value) {
              this.$store.commit('setPartAudio', value)
            }
          },
          part_attachmentFilesList: {
            get () {
              return this.$store.state.app.part_attachmentFilesList
            },
            set (value) {
              this.$store.commit('setPartAttachmentFilesList', value)
            }
          },
          score: {
            get () {
              return this.$store.state.app.score
            },
            set (value) {
              this.$store.commit('setScore', value)
            }
          },
          answerMsg: {
            get () {
              return this.$store.state.app.answerMsg
            },
            set (value) {
              this.$store.commit('setAnswerMsg', value)
            }
          },
          getOverall () {
            return this.$store.state.app.overall
          },
        },
        data() {
            return {
                name: '',
                questionTab: 0,
                activeName: 'first',
                activeName2: 'first_1',
                dialogVisible: false,
                dialogImageUrl: '',
                is_click:false,
                is_publish:false,
                allname: window.localStorage.getItem('name'),
                papername:'',
                paper_score:'',
                user_score: '',
                question_list:"",
                question_id_list: null,
                question_img_list: null,
                record_id: null,
                vx_flag: false,
                wb_flag: false,
                reject_flag: false,
                is_reject: this.$route.params.is_reject,
                reject_tip: false,
                reject_text: '',
                get_reject: null,
                level_data: [],
                type: this.$route.params.object_type,
                is_correct_teacher: false,
                both_flag: false,
                defaultProps:{
                  children: 'list'
                }
            };
        },
        mounted(){
          this.name = window.localStorage.getItem('user_no')
          console.log(this.$route.params);
        },
        methods:{
            saveAll(){
              const {
                comment_type,
                exercise_id,
                record_id,
                correct_user,
                object_type,
                object_id,
                tiku_user_id,
                sso_id,
                level_no,
                comment_object_id
              } = this.$route.params
              let params = {
                comment_type: comment_type,
                exercise_id: exercise_id,
                record_id: record_id,
                correct_user: correct_user,
                object_type: object_type,
                object_id: object_id,
                tiku_user_id: tiku_user_id,
                sso_id: sso_id,
                correct_score: this.score,
                level_no: level_no,
                comment_object_id: comment_object_id
              }
              if (Number(this.score) > this.$route.params.score) {
                this.$confirm('教师评分超过本题总分，请检查后重新输入', '', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                }).catch(() => {
                })
                return
              }
              if (comment_type === '0') { // 保存总评
                params.comment_text = this.comments
                let appendant = []
                if (this.upload.media_id) {
                  let uploadObj = {
                    file_url: this.upload.url,
                    file_type: this.upload.type,
                    is_lock: 0,
                    media_id: this.upload.media_id,
                    file_name: ''
                  }
                  // uploadObj = JSON.stringify(uploadObj)
                  appendant.push(uploadObj)
                }
                if (this.audio.media_id) {
                  let audioObj = {
                    file_url: this.audio.url,
                    file_type: this.audio.type,
                    is_lock: 0,
                    media_id: this.audio.media_id,
                    file_name: ''
                  }
                  appendant.push(audioObj)
                }
                if (this.attachmentFilesList.length > 0) {
                  // this.attachmentFilesList.map((item) => {
                  //   item.pop_flag = 0
                  // })
                  appendant = [...appendant, ...this.attachmentFilesList]
                }
                params.appendant = JSON.stringify(appendant)
              } else { // 保存个页面点评
                params.comment_text = this.part_comments
                let appendant = []
                if (this.part_upload.media_id) {
                  let uploadObj = {
                    file_url: this.part_upload.url,
                    file_type: this.part_upload.type,
                    is_lock: 0,
                    media_id: this.part_upload.media_id,
                    file_name: ''
                  }
                  // uploadObj = JSON.stringify(uploadObj)
                  appendant.push(uploadObj)
                }
                if (this.part_audio.media_id) {
                  let audioObj = {
                    file_url: this.part_audio.url,
                    file_type: this.part_audio.type,
                    is_lock: 0,
                    media_id: this.part_audio.media_id,
                    file_name: ''
                  }
                  appendant.push(audioObj)
                }
                if (this.part_attachmentFilesList.length > 0) {
                  // this.part_attachmentFilesList.map((item) => {
                  //   item.pop_flag = 0
                  // })
                  appendant = [...appendant, ...this.part_attachmentFilesList]
                }
                params.appendant = JSON.stringify(appendant)
              }
              if ($('.over_words').length) {
                this.$confirm('最多输入1000个字', '', {
                  confirmButtonText: '确认',
                  cancelButtonText: '取消',
                  type: 'warning',
                }).then(() => {
                }).catch(() => {
                });
                return
              }
              params.correct_from = this.$route.query.correct_from ? this.$route.query.correct_from : 1
              console.log('保存参数', params)
              this.$api.SAVECOMMENT(params).then(res => {
                if (res.retcode === 0) {
                  this.$message({
                    message: '保存成功',
                    type: 'success',
                    onClose: () => {
                    }
                  });
                } else {
                  this.$message.error(res.message)
                }
              })
              if (this.answerMsg.msg) {
                let answerParams = {
                  msg_id: this.answerMsg.msg_id,
                  msg_pid: this.answerMsg.msg_pid,
                  msg: this.answerMsg.msg,
                  correct_from: this.$route.query.correct_from ? this.$route.query.correct_from : 1
                }
                this.$api.REPLYMSG(answerParams).then((res) => {
                }).catch((err) => {
                  console.log(err)
                })
              }
    },
            tomain_index(){
              const view = this.$router.resolve({
                path: `/homework-info/main/${this.$route.params.object_id}/${this.$route.params.record_id}/${this.$route.params.tiku_user_id}/${this.$route.params.object_type}/${this.$route.params.exercise_id}/${this.$route.params.correct_user}/${this.$route.params.sso_id}/0/''/0/${this.$route.params.is_release}/${this.$route.params.is_reject}`,
                query: this.$route.query
              })
              window.location.href = view.href
              $('.eb-content').find('.is-current').removeClass('is-current')
            },
            handleNodeClick(data) {
              $('.warn').removeClass('warn')
              $('.over_score').remove()
              if(data.level === 0 || data.level === 1){
                this.$store.commit('setLevelData', data)
                const view = this.$router.resolve({
                  path: `/homework-info/first/${this.$route.params.object_id}/${this.$route.params.record_id}/${this.$route.params.tiku_user_id}/${this.$route.params.object_type}/${this.$route.params.exercise_id}/${this.$route.params.correct_user}/${this.$route.params.sso_id}/${data.level}/${data.block_id}/2/${this.$route.params.is_release}/${this.$route.params.is_reject}`,
                  query: this.$route.query
                })
                window.location.href = view.href
              } else {
                this.$store.commit('setStudentsAnswer', data)
                const view = this.$router.resolve({
                  path: `/homework-info/subject/${this.$route.params.object_id}/${this.$route.params.record_id}/${this.$route.params.tiku_user_id}/${this.$route.params.object_type}/${this.$route.params.exercise_id}/${this.$route.params.correct_user}/${this.$route.params.sso_id}/0/${data.block_id}/3/${this.$route.params.is_release}/${this.$route.params.is_reject}/${data.form}/${data.score}/${data.is_new}`,
                  query: this.$route.query
                })
                window.location.href = view.href
              }
            },
            handleNodesClick(data){
              if(data.level === 2){
                this.$store.commit('setLevelData', data)
                const view = this.$router.resolve({
                  path: `/homework-info/first/${this.$route.params.object_id}/${this.$route.params.record_id}/${this.$route.params.tiku_user_id}/${this.$route.params.object_type}/${this.$route.params.exercise_id}/${this.$route.params.correct_user}/${this.$route.params.sso_id}/${data.level}/${data.level_id}/2/${this.$route.params.is_release}/${this.$route.params.is_reject}`,
                  query: this.$route.query
                })
                window.location.href = view.href
              } else if(data.level === 3){
                this.$store.commit('setLevelData', data)
                const view = this.$router.resolve({
                  path: `/homework-info/second/${this.$route.params.object_id}/${this.$route.params.record_id}/${this.$route.params.tiku_user_id}/${this.$route.params.object_type}/${this.$route.params.exercise_id}/${this.$route.params.correct_user}/${this.$route.params.sso_id}/${data.level}/${data.level_id}/2/${this.$route.params.is_release}/${this.$route.params.is_reject}`,
                  query: this.$route.query
                })
                window.location.href = view.href
              } else if(data.level === 4){
                this.$store.commit('setLevelData', data)
                const view = this.$router.resolve({
                  path: `/homework-info/third/${this.$route.params.object_id}/${this.$route.params.record_id}/${this.$route.params.tiku_user_id}/${this.$route.params.object_type}/${this.$route.params.exercise_id}/${this.$route.params.correct_user}/${this.$route.params.sso_id}/${data.level}/${data.level_id}/2/${this.$route.params.is_release}/${this.$route.params.is_reject}`,
                  query: this.$route.query
                })
                window.location.href = view.href
              } else if(!data.children){
                this.$store.commit('setStudentsAnswer', data)
                const view = this.$router.resolve({
                  path: `/homework-info/subject/${this.$route.params.object_id}/${this.$route.params.record_id}/${this.$route.params.tiku_user_id}/${this.$route.params.object_type}/${this.$route.params.exercise_id}/${this.$route.params.correct_user}/${this.$route.params.sso_id}/0/${data.level_id}/3/${this.$route.params.is_release}/${this.$route.params.is_reject}/${data.form}/${data.score}/${data.is_new}`,
                  query: this.$route.query
                })
                window.location.href = view.href
              }
            },
            get_rejecttext(){
              this.$api.GETREJECTUSERANSWER({
                exercise_id: this.$route.params.exercise_id,
                sso_id: this.$route.params.sso_id,
                object_type: this.$route.params.object_type,
                correct_from: this.$route.query.correct_from ? this.$route.query.correct_from : 1
              }).then((res) => {
                this.get_reject = res.data
              })
            },
            reject_comment(){
              if(this.reject_text == ''){
                this.reject_tip = true
              } else {
                this.$api.SAVEREJECTUSERANSWER({
                  exercise_id: this.$route.params.exercise_id,
                  object_type: this.$route.params.object_type,
                  record_id: this.$route.params.record_id,
                  sso_id: this.$route.params.sso_id,
                  msg: this.reject_text,
                  correct_from: this.$route.query.correct_from ? this.$route.query.correct_from : 1
                }).then((res) => {
                  if (res.retcode === 0) {
                    this.reject_text = ''
                    this.reject_flag = false
                    this.reject_tip = false
                    this.$message({
                      message: '驳回成功',
                      type: 'success'
                    })
                  } else {
                    this.$message({
                      message: res.message || '驳回成功',
                      type: 'error'
                    })
                  }
                }).catch(err => {
                  console.log(err)
                })
              }
            },
            htmlfilter (val) {
              val = val.replace(/<br\/>/g, '').replace(/<p>/g, '')
              if (val.indexOf('img') != -1 && val.indexOf('img') == 1) {
                return '[图片]'
              } else if (val.indexOf('img') != -1 && val.indexOf('img') < 4) {
                return val.substr(0, 2) + '[图片]'
              } else {
                return val.replace(/<img/g, '')
              }
            },
            vx_show(){
              this.vx_flag = true
            },
            vx_hide(){
              this.vx_flag = false
            },
            wb_show(){
              this.wb_flag = true
            },
            wb_hide(){
              this.wb_flag = false
            },
            handleClick () {
              this.$nextTick(() => {
                this.$refs.box[this.questionTab].scrollTop = this.$refs[this.activeName][this.questionTab].offsetTop;
              })
            },
            handleClick2 () {
              this.$nextTick(() => {
                this.$refs.box2[this.questionTab].scrollTop = this.$refs[this.activeName2][this.questionTab].offsetTop;
              })
            },
            handlePictureCardPreview (imgUrl) {
              this.dialogImageUrl = imgUrl;
              this.dialogVisible = true;
            },
            handleDownload(file) {
              console.log('下载图片');
              var x = new XMLHttpRequest();
              x.open("GET", file.url, true);
              x.responseType = 'blob';
              x.onload=function(e){
                  var url = window.URL.createObjectURL(x.response)
                  var a = document.createElement('a');
                  a.href = url
                  a.download = file.name || "photo";
                  a.click();
              }
              x.send();
            },
            // 跳转页面
            goPage (router) {
              const view = this.$router.resolve({
                  path:router
              })
              window.open(view.href, '_blank')
            },
            // 处理数据
            changeData(array){
              for (let i = 0; i < array.length; i++) {
                var obj = array[i];
                for(var key in obj){
                  if (key == 'question_list') {
                    obj['list'] = obj[key];
                    delete obj[key];
                  }
                  if (key == 'stem') {
                    obj['block_name'] = obj[key];
                    delete obj[key];
                  }
                  if (key == 'question_id') {
                    obj['block_id'] = obj[key];
                    delete obj[key];
                  }
                }
                if (obj.list) {
                  this.changeData(obj.list)
                }
              }
              return array
            },
            changeDatas(array){
              for (let i = 0; i < array.length; i++) {
                var obj = array[i];
                for(var key in obj){
                  if (key == 'question_list' && obj.question_list != '') {
                    obj['children'] = obj[key];
                    delete obj[key];
                  }
                  if (key == 'stem') {
                    obj['level_name'] = obj[key];
                    delete obj[key];
                  }
                  if (key == 'question_id') {
                    obj['level_id'] = obj[key];
                    delete obj[key];
                  }
                }
                if (obj.children) {
                  this.changeDatas(obj.children)
                }
              }
              return array
            },
            getLevel() {
              if(this.type == 0){
                this.$api.GETEXERCISEPAPERREPORT({
                  record_id: this.$route.params.record_id,
                  object_id: this.$route.params.object_id,
                  exercise_id: this.$route.params.exercise_id,
                  correct_from: this.$route.query.correct_from ? this.$route.query.correct_from : 1
                }).then((res) => {
                  if(res.retcode == 0){
                    if(res.data.list.length==1 && res.data.list[0].total_num == 1) {
                      this.$store.commit('setOverall', false);
                    } else {
                      this.$store.commit('setOverall', true);
                    }
                    this.papername = res.data.paper_name
                    this.user_score = res.data.user_score
                    this.paper_score = res.data.total_score;
                    window.localStorage.setItem('user_score', this.user_score);
                    window.localStorage.setItem('paper_score', this.paper_score);
                    res.data.list = this.changeData(res.data.list)
                    this.level_data = res.data.list
                    this.$nextTick(()=>{
                      $('.paper_name').click()
                    })
                  }
                }).catch((err) => {
                  this.getLevel()
                })
              } else {
                this.$api.GETEXERCISEPRACTICEREPORT({
                  record_id: this.$route.params.record_id,
                  object_id: this.$route.params.object_id,
                  exercise_id: this.$route.params.exercise_id,
                  correct_from: this.$route.query.correct_from ? this.$route.query.correct_from : 1
                }).then((res) => {
                  if(res.retcode == 0){
                    if (res.data.length==1 && res.data[0].total_num == 1) {
                      this.$store.commit('setOverall', false);
                    } else {
                      this.$store.commit('setOverall', true);
                    }
                    this.papername = res.data.paper_name || window.localStorage.getItem('name')
                    this.level_data = this.changeDatas(res.data)
                    this.$nextTick(()=>{
                      document.querySelector('.el-tree-node__content').click()
                    })
                  }
                }).catch((err) => {
                  this.getLevel()
                })
              }
            },
            getInfo() {
                this.$api.GETEXERCISEQUESTIONINFO({
                    object_id: this.$route.params.object_id,
                    record_id: this.$route.params.record_id,
                    appid: 'pigai',
                    user_id: this.$route.params.sso_id,
                    object_type: this.$route.params.object_type
                }).then((res) => {
                    if(res.retcode == 0){
                        console.log(res);
                    }
                })
            },
            viewMetrail:function(item) {
                const view = this.$router.resolve({
                    path:'/view-paper-material/'+ item.question_id + '/' + this.$route.params.tiku_paper_id + '/' + this.$route.params.record_id + '/' + this.papername + '/' + item.question_num
                })
                window.open(view.href, '_blank')
            },
            toChies:function(num){
                    const upperNumbers= [ '一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '百', '千', '万', '亿']
                    const length = String(num).length
                    if (length === 1) {
                      return upperNumbers[num]
                    } else if (length === 2) {
                      if (num === 9) {
                        return upperNumbers[num]
                      } else if (num > 9 && num < 19) {
                        const index = String(num)
                        return '十' + upperNumbers[index.charAt(1)]
                      } else {
                        const index = String(num)
                        if(index.charAt(1)==9){
                            return upperNumbers[index.charAt(0)] + '十'
                        }else{
                            return upperNumbers[index.charAt(0)-1] + '十' + upperNumbers[index.charAt(1)]
                        }

                      }
                    } else {
                      return ''
                    }
            },
            openClose:function(i,type){
                this.is_click = !this.is_click;
                this.question_list[i][type] = !this.question_list[i][type];
                // this.question_list[i][type] = false;
            },
            // 保存并发布
            savePub() {
              const {
                comment_type,
                exercise_id,
                record_id,
                correct_user,
                object_type,
                object_id,
                tiku_user_id,
                sso_id,
                level_no,
                comment_object_id
              } = this.$route.params
              let params = {
                comment_type: comment_type,
                exercise_id: exercise_id,
                record_id: record_id,
                correct_user: correct_user,
                object_type: object_type,
                object_id: object_id,
                tiku_user_id: tiku_user_id,
                sso_id: sso_id,
                correct_score: this.score,
                level_no: level_no,
                comment_object_id: comment_object_id
              }
              if (comment_type === '0') { // 保存总评
                params.comment_text = this.comments
                let appendant = []
                if (this.upload.media_id) {
                  let uploadObj = {
                    file_url: this.upload.url,
                    file_type: this.upload.type,
                    is_lock: 0,
                    media_id: this.upload.media_id,
                    file_name: ''
                  }
                  appendant.push(uploadObj)
                }
                if (this.audio.media_id) {
                  let audioObj = {
                    file_url: this.audio.url,
                    file_type: this.audio.type,
                    is_lock: 0,
                    media_id: this.audio.media_id,
                    file_name: ''
                  }
                  appendant.push(audioObj)
                }
                if (this.attachmentFilesList.length > 0) {
                  appendant = [...appendant, ...this.attachmentFilesList]
                }
                params.appendant = JSON.stringify(appendant)
              } else { // 保存个页面点评
                params.comment_text = this.part_comments
                let appendant = []
                if (this.part_upload.media_id) {
                  let uploadObj = {
                    file_url: this.part_upload.url,
                    file_type: this.part_upload.type,
                    is_lock: 0,
                    media_id: this.part_upload.media_id,
                    file_name: ''
                  }
                  appendant.push(uploadObj)
                }
                if (this.part_audio.media_id) {
                  let audioObj = {
                    file_url: this.part_audio.url,
                    file_type: this.part_audio.type,
                    is_lock: 0,
                    media_id: this.part_audio.media_id,
                    file_name: ''
                  }
                  appendant.push(audioObj)
                }
                if (this.part_attachmentFilesList.length > 0) {
                  appendant = [...appendant, ...this.part_attachmentFilesList]
                }
                params.appendant = JSON.stringify(appendant)
              }
              if ($('.over_words').length) {
                this.$confirm('最多输入1000个字', '', {
                  confirmButtonText: '确认',
                  cancelButtonText: '取消',
                  type: 'warning',
                }).then(() => {
                }).catch(() => {
                });
                return
              }
              params.correct_from = this.$route.query.correct_from ? this.$route.query.correct_from : 1
              this.$api.SAVECOMMENT(params).then(res => {
                if (res.retcode === 0) {
                  this.$message({
                    message: '保存成功',
                    type: 'success'
                  });
                  this.publish()
                } else {
                  this.$message.error(res.message)
                }
              })
              if (this.answerMsg.msg) {
                let answerParams = {
                  msg_id: this.answerMsg.msg_id,
                  msg_pid: this.answerMsg.msg_pid,
                  msg: this.answerMsg.msg,
                  correct_from: this.$route.query.correct_from ? this.$route.query.correct_from : 1
                }
                this.$api.REPLYMSG(answerParams).then((res) => {
                }).catch((err) => {
                  console.log(err)
                })
              }
            },
            publish:function(){
                this.$api.PUBEXERCISECORRECT({
                  exercise_id: this.$route.params.exercise_id,
                  record_id: this.$route.params.record_id,
                  correct_user: this.$route.params.correct_user,
                  object_type: this.$route.params.object_type,
                  object_id: this.$route.params.object_id,
                  tiku_user_id: this.$route.params.tiku_user_id,
                  sso_id: this.$route.params.sso_id,
                  correct_from: this.$route.query.correct_from ? this.$route.query.correct_from : 1
                }).then(res => {
                  console.log('发布给学员结果：', res);
                  if (res.retcode == 0) {
                    var bc = new BroadcastChannel('paper_list');
                    bc.postMessage('pageRefresh');
                    this.$message({
                      message: '发布成功',
                      type: 'success',
                      onClose: () => {
                        window.close();
                      }
                    });
                  } else if (res.retcode == 10009) {
                    let setTeacherRemark_item;
                    let noTeacherRemark = [];
                    this.question_list.forEach((item, index) => {
                        if (item.question_id == res.data[0]) {
                          setTeacherRemark_item = item;
                        }
                        if(res.data.includes(Number(item.question_id))){
                            noTeacherRemark.push(index + 1);
                        }
                    })
                    if (!setTeacherRemark_item || !noTeacherRemark.length) {
                      this.$message.error('前端错误-没有获取到未点评试题信息');
                      return;
                    }
                    this.$confirm('<p style="color:#bbb;"><span style="color:red;">第'+ noTeacherRemark.join("、") +'题</span>没有点评完成，只有点评完成之后，才能发布给学员</p>', '发布失败', {
                      confirmButtonText: '去点评',
                      cancelButtonText: '取消',
                      type: 'error',
                      showClose:false,
                      closeOnClickModal:false,
                      dangerouslyUseHTMLString:true,
                    }).then(() => {
                        this.goPage(`/paper-assess/${this.record_id}/${this.$route.params.user_id}/${this.$route.params.sso_id}/${this.$route.params.iip_paper_id}/${this.$route.params.tiku_paper_id}/${setTeacherRemark_item.question_id}/${setTeacherRemark_item.has_score_standard ? setTeacherRemark_item.question_correct.question_score :setTeacherRemark_item.question_correct.score}/${setTeacherRemark_item.score_mode}/${setTeacherRemark_item.need_score}/${(setTeacherRemark_item.question_answer_sheet_arr && setTeacherRemark_item.question_answer_sheet_arr.length) || 0}/${setTeacherRemark_item.comment_mode}/${this.papername}/${setTeacherRemark_item.question_num}`)
                    }).catch(() => {
                    });
                  }else if (res.retcode == 10008) {
                    this.$message.error(`试卷的批改总分(${res.data})超过了试卷的设置的总分`)
                  } else {
                    this.$message.error(res.message);
                  }
                })
            },
            tabClick:function(tab) {
                this.$nextTick(() => {
                    this.questionTab = tab.index;
                    this.activeName = 'first';
                    this.activeName2 = 'first_1';
                    if (this.$refs.box && this.$refs.box[this.questionTab]) this.$refs.box[this.questionTab].scrollTop = 0;
                    if (this.$refs.box2 && this.$refs.box2[this.questionTab]) this.$refs.box2[this.questionTab].scrollTop = 0;
                    document.querySelector('.el-tabs__content').scrollTop = '0'
                })

            }
        },
        created () {
            if (this.$route.params.correct_user.indexOf(localStorage.getItem('user_no')) == -1) {
              this.is_publish = true
            }
            this.record_id = this.$route.params.record_id;
            this.is_correct_teacher = this.$route.params.correct_user.indexOf(localStorage.getItem('user_no')) != -1;
            if(this.is_publish){
              this.both_flag = false
            } else {
              if(this.is_correct_teacher){
                if (this.is_reject == '0') {
                  this.both_flag = false
                } else {
                  this.both_flag = true
                }
              } else {
                this.both_flag = false
              }
            }
            this.getLevel()
            this.getInfo()
            this.get_rejecttext()
            var bc = new BroadcastChannel('paper_channel');
            var _this = this;
            bc.onmessage = function (ev) {
              if (_this.question_list.length) {
                _this.question_list = _this.question_list.map(item => {
                  if (item.question_id == ev.data) {
                    item.is_man_made_correct = 1;
                  }
                  return item;
                })
              }
            }
        }
    }
</script>

<style lang="less">
    .status_image{
        width: 15px;
        height: 15px;
        vertical-align: middle;
    }
    .diagnose_content{
       font-size: 14px;
       margin-bottom: 20px;
    }
    .diagnose_type_title{
        line-height: 47px;
    }
    .diagnose_title{
        padding-left: 16px;
        margin:0;
        line-height: 47px;
    }
    .diagnose_item_content{
        padding-left: 30px;
        line-height: 47px;
    }
    .diagnose_item_content p{
        margin:0;
    }
    .line{
        width: 100%;
        height: 1px;
        background: #ccc;
    }
    .paper-info-page .content .el-upload.el-upload--picture-card {
      display: none;
    }
    .el-dialog__body{
      padding: 0 20px;
      textarea{
        width: 100%;
        height: 70px;
        padding: 10px;
        resize: none;
        border-radius: 4px;
      }
      .reject_tip{
        color: #ff0000;
      }
    }
    .desc-html{
      width: 83px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      height: 20px;
      line-height: 20px;
      * {
        margin: 0;
        padding:0;
      }
      p:first-child{
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 83px;
      }
      p:first-child + *{
        display:none
      }
    }
</style>
<style>
    /*滚动条*/
    ::-webkit-scrollbar {
      width: 18px;
      height: 14px;
    }
    ::-webkit-scrollbar-track,
    ::-webkit-scrollbar-thumb {
      border-radius: 999px;
      border: 5px solid transparent;
    }
    ::-webkit-scrollbar-thumb {
      min-height: 20px;
      background-clip: content-box;
      box-shadow: 0 0 0 5px rgba(174,174,174,1) inset;
    }
    ::-webkit-scrollbar-corner {
      background: transparent;
    }
    .left{
        float: left;
    }
    .half{
        width: 50%;
        min-height: 1px;
    }
    .paper-info-page .el-input--suffix span.el-input__suffix{
        display: none !important;
    }
    .paper-info-page .user-answer-content{
        margin-bottom: 20px;
    }
    .paper-info-page .item-title{
        font-size: 16px;
        line-height: 44px;
        font-weight: bolder;
    }
    .paper-info-page .item-content{
        font-size: 14px;
        /* padding-left: 16px; */
    }
    .paper-info-page .item-content p{
        margin:inherit !important;
        line-height: 26px;
    }
    .paper-info-page .time-info{
        font-size: 16px;
    }
    .paper-info-page .time-info .score{
        margin-left: 200px;
    }
    .paper-info-page .answer-title{
        font-size: 14px;
        line-height: 66px;
        padding-left: 10px;
        box-sizing: border-box;
        position: relative;
    }
    .paper-info-page .answer-title .open-close{
        position: absolute;
        right:0;
        top:0;
        color: #aaa;
        cursor: pointer;
    }
    .paper-info-page .answer-title::before{
        content: "";
        position: absolute;
        left:0;
        top:25px;
        height: 15px;
        width: 3px;
        background-color: #1890ff;
    }
    .paper-info-page{
        width: 100%;
        padding: 0 30px;
        height: 100%;
        min-height: 500px;
    }

    .paper-info-page .operate-btn{
        float: right;
    }
    .paper-info-page .content{
        padding-top: 100px;
        padding-bottom: 60px;
        box-sizing: border-box;
        height: 100%;
    }
    .paper-info-page .content-container{
        height: 100%;
    }
    .paper-info-page .page-tab.el-tabs{
        padding-top: 40px;
        padding-bottom: 10px;
        box-sizing: border-box;
        height: 100%;
    }

    .paper-info-page .page-tab>.el-tabs__header{
        position: fixed;

    }
    .paper-info-page .page-tab>.el-tabs__content{
        height: 100%;
        box-sizing: border-box;
        padding-top: 40px;
        overflow: auto;

    }
    .paper-info-page .page-tab.el-tabs--border-card{
        background: inherit;
        border: none;
        box-shadow: none;
    }
    .paper-info-page .teacher-comment{
        height: 60px;
        width: 100%;
        padding: 0 0px;
        box-sizing: border-box;
        position: fixed;
        bottom:0;
        left:0;
        z-index: 9;

    }
    .paper-info-page .comment-container{
        box-sizing: border-box;
        padding: 12px 30px;
        background-color: #fff;
        height: 100%;
        width: 100%;
    }
    .paper-info-page .answer-content-item{
        font-size: 14px;
        margin-top: 25px;
    }
    .paper-info-page .score-point .box-card{
        margin-top: 14px;
    }
    .paper-info-page .score-point .el-input{
        width: 45%;
    }
    .paper-info-page .score-point .el-row{
        line-height: 40px;
    }

    .paper-info-page .score-point .key-item{
        margin-top: 10px;
        line-height: 20px;
    }
    .paper-info-page .score-point .key-item .key-line .choose,.paper-info-page .score-point .key-item .key-line.choose{
        color: #1890ff;
    }
    .paper-info-page .answer-left{
        text-indent: 2em;
        padding-right: 35px;
        line-height: 38px;
        box-sizing: border-box;
    }
    .paper-info-page .image-useranswer .answer-left{
        text-indent: inherit;
    }
    .paper-info-page .answer-left .image{
        width:45%;
        margin-right: 2%;
        height: 136px;
    }
    .paper-info-page .answer-right .answer-type{
        line-height: 38px;
        /*text-align: center;*/
    }
    .paper-info-page .answer-right .answer-type {
        /*margin-top: 25px;*/
        margin-bottom: 20px;
    }
/*    .paper-info-page .answer-right .answer-type:nth-child(1){
        margin-top: 0px;
    }*/
    .paper-info-page .structure-standard div:nth-child(1) .answer-type{
        margin-top: 0px;
    }
    .paper-info-page .structure-standard .answer-type{
        margin-top: 25px;
    }
/*    .paper-info-page .structure-standard .answer-type:nth-child(1){
        margin-top: 0px !important;
    }*/
    .paper-info-page .answer-right .answer-type .image{
        vertical-align: middle;
        margin-right: 10px;
    }
    .paper-info-page .item-answer .des-info{
        font-size: 14px;
        text-indent: 2em;
    }
    .paper-info-page .student-score.red{
        color: red;
    }
    .paper-info-page .font-s{
        font-size: 16px;
    }
    .paper-info-page .correction-score{
        position: relative;
    }
    .paper-info-page .score-error{
        color: red;
        font-size: 12px;
        position: absolute;
        top:30px;
        left:83px;
    }
    .paper-info-page .advantage-title{
        font-size: 14px;
        line-height: 42px;
        padding-left: 10px;
    }
    .paper-info-page .advantage-info{
        font-size: 14px;
        padding-left: 34px;
    }
    .paper-info-page .score-point .el-card__body{
        padding:10px;
    }
    .paper-info-page .page-tab.el-tabs--border-card>.el-tabs__header{
        border-bottom: none;
    }
    .paper-info-page .page-tab > .el-tabs__header{
        position: fixed;
        left:0;
        top:100px;
        z-index: 10;
        width: 100%;
        padding:0 30px;
        box-sizing: border-box;
        border:none;
    }
    .paper-info-page .page-tab > .el-tabs__header > .el-tabs__nav-wrap{
        min-width: 1280px;
        overflow:auto;
        border-top: 1px solid #dcdfe6;
        border-bottom: 1px solid #dcdfe6;
    }
    .paper-info-page .page-tab > .el-tabs__header > .el-tabs__nav-wra > .el-tabs__nav{
        min-width: 1280px;
        width: 100%;
        overflow-x: auto;
        overflow-y: hidden;
    }
    .paper-info-page .page-tab > .el-tabs__content{
        height: 100%;
        box-sizing: border-box;
        overflow: auto;
        /*min-height: 600px;*/
    }
    .paper-info-page .info_span{
        text-decoration: underline;
    }
    .paper-info-page .info{
        line-height: 40px;
    }
    .paper-info-page .info_border{
        /*position: relative;*/
        border-bottom: 1px #1890ff dashed;
    }
    .paper-info-page .info_border.red{
        /*position: relative;*/
        border-bottom: 1px #f24a78 dashed;
    }
/*    .paper-info-page .info_border .score-point{
        position: absolute;
        right:0;
        width:50px !important;
        display: inline-block;
        bottom:-26px;
        font-size:12px;
    }*/
    .paper-info-page .info_border .tag{
        position: relative;
        /*border-bottom: 1px red dashed;*/
    }
    .paper-info-page .info_border .tag.red:after{
        color: #f24a78;
    }
    .paper-info-page .info_border .tag:after{
        content: attr(attr-score);
        position: absolute;
        width: 61px;
        line-height: 12px;
        top: 100%;
        left: -30px;
        color: #1890ff;
        font-size: 12px;
    }
   .clearfix:after {visibility: hidden;display: block;font-size: 0;content: " ";clear: both;height: 0;}
   .clearfix{*zoom:1;}
</style>
<style lang="less">
.paper-info-page {
  padding: 0;
  .blue{
      color: #1890ff;
      cursor: pointer;
  }
  .el-button{
    padding: 8px 12px;
    font-size: 12px;
  }
  .title {
    height: 59px;
    border-bottom: 1px solid #e5e5e5;
    width: 100%;
    padding: 0 360px;
    box-sizing: border-box;
    position: fixed;
    top:0;
    left:0;
    background-color: #fff;
    z-index: 99;
    display: flex;
    .title-left {
      flex: 1 0 auto;
      height: 100%;
      .row-1 {
        height: 59px;
        line-height: 60px;
        font-weight: bolder;
      }
      .score {
        font-size: 14px;
        font-weight: normal;
      }
    }
    .title-right {
        flex: 0 0 auto;
        height: 100%;
        line-height: 60px;
        .reject{
          color: red;
          border: 1px solid red;
        }
        .el-dropdown{
          height: 59px;
          margin-left: 20px;
        }
    }
  }
  .content {
    .part {
      &.part-flex {
        display: flex;
        .item-content {
          max-height: 400px;
          overflow-y: scroll;
          overflow-x: hidden;
          word-break: break-all;
        }
      }
      .item-title {
        font-weight: bolder;
      }
      .item-content {
        font-size: 14px;
        line-height: 25px;
        padding: 0;
        // p {
        //     margin: none !important;
        //     margin: inherit !important;
        //     line-height: 26px;
        // }
        .part-1 {
          .part-title {
            &::before {
                content: "";
                position: absolute;
                left: 0;
                top: 4px;
                height: 17px;
                width: 3px;
                background-color: #1890ff;
            }
            font-size: 14px;
            font-weight: bolder;
            position: relative;
            height: 25px;
            padding-left: 5px;
            margin: 10px 0;
          }
          .part-content {
            .all-words {
              margin-top: 25px;
            }
            >.image{
                width:45%;
                margin-right: 2%;
                height: 136px;
            }
            .answer-type .image {
                vertical-align: middle;
                margin-right: 10px;
            }
          }
        }
      }
      .left {
        flex: 50%;
      }
      .right {
        flex: 50%;
      }
    }
  }
  .paper_name{
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    padding: 0 20px;
    font-weight: bold;
    cursor: pointer;
    img{
      vertical-align: middle;
      margin-right: 10px;
    }
  }
  .el-tree-node__expand-icon.el-icon-caret-right{
    position: absolute;
    right: 26px;
  }
  .el-tree-node__content{
    height: 36px;
  }
  .first_style{
    font-weight: bold;
  }
  .children_style{
    font-size: 12px;
    display: inline-block;
    width: 46px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .ask_tip{
    position: absolute;
    right: 8px;
    font-size: 12px;
    color: #ff0000;
  }
  .assembly_level{
    display: flex;
    align-items: center;
    margin-left: 20px;
    font-size: 14px;
  }
  .assembly_type{
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-right: 10px;
    background: url(../../../static/images/videos.png);
  }
  .el-tree-node.is-current > .el-tree-node__content{
    color: #6594fe;
  }
  .el-tree-node.is-current::before{
    content: '';
    position: absolute;
    left: 0;
    margin-top: 7px;
    width: 4px;
    height: 20px;
    border-radius: 2px;
    background-color: #6594fe;
    box-shadow: 2px 0px 4px 0px rgba(101, 148, 254, 0.4);
  }
  .el-tree-node.is-current > .el-tree-node__content .assembly_type{
    background: url(../../../static/images/video.png);
  }
  .el-icon-caret-right:before{
    content: '';
    display: block;
    width: 12px;
    height: 6px;
    background:url('../../../static/images/down.png');
    background-size:cover;
  }
  .is-leaf.el-icon-caret-right:before{
    background: none;
  }
  .el-tree-node__expand-icon.expanded{
    transform: rotate(180deg);
  }
  .el-main p, .el-footer p{
    line-height: normal;
  }
  .default_evaluate{
      z-index: 99;
      position: fixed;
      width: 100%;
      height: 100%;
      background: rgba(0,0,0,.4);
      top: 0;
      left: 0;
      .default_evaluate_box{
          position: absolute;
          width: 600px;
          height: 200px;
          top: 50%;
          left: 50%;
          transform: translate(-50%,-50%);
          background: #fff;
      }
  }
  .el-footer{
    padding: 0;
    background: #1d2b3f;
    .common{
      width: 1200px;
      margin: 0 auto;
      padding-top: 62px;
      .l{
        float: left;
      }
      .school{
        width: 698px;
        margin-left: 180px;
        .p1>a{
          font-size: 16px;
          font-weight: bold;
          color: #fff;
          cursor: default;
        }
        .p2{
          margin:26px auto 10px;
          a{
            display: inline-block;
            font-size: 12px;
            color: #fff;
            padding-right: 4px;
            padding-left: 4px;
            border-right: 2px solid #a8abb0;
            text-decoration: none;
          }
          a:hover{
            color:#e00;
          }
          a:nth-child(1){
            padding-left: 0px;
          }
          a:nth-child(6){
            border: none;
          }
        }
        .p3{
          font-size: 12px;
          color: #fff;
        }
      }
      .follow_me{
        .p4{
          font-size: 16px;
          font-weight: bold;
          color: #fff;
        }
        .weibo{
          cursor: pointer;
          position: relative;
          width: 40px;
          height: 40px;
          margin-right: 60px;
          background: url(../../../static/images/weibo.png) top center no-repeat;
          .wbtc{
            position: absolute;
            left: -70px;
            top: -97px;
            border-radius: 8px;
            width: auto;
            height: 83px;
            overflow: hidden;
            background-color: rgb(255, 255, 255);
            background-position: initial initial;
            background-repeat: initial initial;
          }
          .v_bottom_round{
            width: 31px;
            height: 14px;
            position: absolute;
            left: 4px;
            top: -15px;
          }
        }
        .public{
          cursor: pointer;
          position: relative;
          width: 40px;
          height: 40px;
          background: url(../../../static/images/public_logo.png) top center no-repeat;
          .weixin_logo{
            position: absolute;
            padding: 10px 10px;
            width: 90px;
            height: 90px;
            border-radius: 8px;
            background: #fff;
            top: -112px;
            right: -25px;
            img{
              width: 100%;
              height: 100%;
            }
          }
          .bottom_round{
            width: 20px;
            height: 10px;
            position: absolute;
            top: -26px;
            right: 10px;
          }
        }
      }
    }
  }
  .dialog_textarea {
    border: 1px solid #DCDFE6;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/homework-info/index.vue